import { CustomerJson } from "@redotech/redo-customer-common/customer";
import { assertNever } from "@redotech/util/type";
import { Call as TelnyxCall } from "@telnyx/webrtc/lib/src/Modules/Verto/webrtc/Call";

export enum WebRTCCallState {
  NEW = "new",
  TRYING = "trying",
  REQUESTING = "requesting",
  RECOVERING = "recovering",
  RINGING = "ringing",
  ANSWERING = "answering",
  EARLY = "early",
  ACTIVE = "active",
  HELD = "held",
  HANGUP = "hangup",
  DESTROY = "destroy",
  PURGE = "purge",
}

export enum CallDirection {
  INBOUND = "inbound",
  OUTBOUND = "outbound",
}

export interface CustomerCallData {
  customerId: string;
  customerCallControlId: string;
  customerNumber: string;
}

// ===== moved from redo/web/src/voice/types.ts =====

export enum UserCallAvailability {
  AVAILABLE = "available",
  IN_CALL = "in-call",
  UNAVAILABLE = "unavailable",
}

export enum CallState {
  RINGING = "ringing",
  ACTIVE = "active",
  CONNECTING = "connecting",
  HANGUP = "hangup",
}

export const displayUserCallAvailability = (
  availability: UserCallAvailability,
) => {
  switch (availability) {
    case UserCallAvailability.AVAILABLE:
      return "Available";
    case UserCallAvailability.IN_CALL:
      return "In call";
    case UserCallAvailability.UNAVAILABLE:
      return "Unavailable";
    default:
      assertNever(availability);
  }
};

export type UserAvailabilities = {
  userId: string;
  availability: UserCallAvailability;
}[];

export interface VoiceAgent {
  name: string;
  imageUrl: string | null;
}

export enum SearchByOption {
  STATE_PROVINCE = "stateProvince",
  AREA_CODE = "areaCode",
  CITY_REGION = "cityRegion",
  STARTS_WITH = "startsWith",
  CONTAINS = "contains",
  ENDS_WITH = "endsWith",
}

export interface TelnyxPhoneNumberRecord {
  best_effort: boolean;
  cost_information: {
    currency: string;
    monthly_cost: string;
    upfront_cost: string;
  };
  features: { name: string }[];
  phone_number: string;
  phone_number_type: string;
  quickship: boolean;
  record_type: string;
  region_information: { region_name: string; region_type: string }[];
  reservable: boolean;
  vanity_format: string | null;
}

export interface Call {
  state: CallState;
  callControlId: string;
  direction: CallDirection;
  startTime: Date;
  remoteCallerNumber: string;
  agents: VoiceAgent[];
  customer: CustomerJson;
  telnyxCall?: TelnyxCall;
}
